module.exports = __webpack_public_path__ + "img/AERO.236016f2.jpg";